import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { DateTime } from "luxon";
import { SelectBoxDialogService } from '@polk_county_public_schools/ngx-pcps-dialogs/selectbox';
import { AppService } from '../../services/app.service';
import { SnackBarService } from '@polk_county_public_schools/ngx-pcps-dialogs/snackbar';
import { UserInfo, UserService } from '../../services/user.service';
import { WaitModalComponent } from '../modals/wait-modal/wait-modal.component';
import { SelectionOption } from '../../classes/selection-option';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { ErrorService } from '../../services/error.service';

@Component({
    selector: 'app-reports-table',
    templateUrl: './reports.component.html',
    imports: [
        MatCardModule,
        MatDividerModule,
        MatButtonModule
    ],
    providers: [
        SelectBoxDialogService
    ]
})
export class ReportsComponent implements OnInit {
    protected readonly destroyRef = inject(DestroyRef);
    protected readonly appSvc = inject(AppService);
    protected readonly matDialog = inject(MatDialog);
    protected readonly selectDlgSvc = inject(SelectBoxDialogService);
    protected readonly snackBarSvc = inject(SnackBarService);
    protected readonly userSvc = inject(UserService);
    protected readonly errorSvc = inject(ErrorService);
    user: UserInfo;
    schoolList: SelectionOption[] = [];

    ngOnInit() {
        this.user = this.userSvc.User;

        this.appSvc.GetSchools().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
            for (let r of res) {
                if (r.SchoolNumber === '0000') {
                    r.SchoolName = 'All Schools';
                }

                let temp: SelectionOption = {
                    Text: r.SchoolName,
                    Value: r.SchoolNumber
                };

                this.schoolList.push(temp);
            }
        });
    }

    scholarshipDetails() {
        let wait = this.matDialog.open(WaitModalComponent);

        this.appSvc.ScholarshipDetailsReport().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
            next: res => {
                wait.close();
                this.saveBlobToFile(res.body, 'ScholarshipDetails_' + DateTime.now().toFormat('MMM_d_y'));
            }, error: error => {
                wait.close();
                this.errorSvc.HandleServiceError(error);
            }
        });
    }

    applicationStatus() {
        let dialog = this.selectDlgSvc.Open({
            disableClose: true,
            TitleText: 'Select',
            MessageText: 'Which school do you want this report to display?',
            Options: this.schoolList,
            //Current: '0000'
        });

        dialog.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(response => {
            if (response == null) {
                return;
            }

            let schoolName = this.schoolList.find(f => f.Value === response).Text.replace(/\s/g, '');

            let wait = this.matDialog.open(WaitModalComponent);

            this.appSvc.ApplicationStatusReport(response).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
                next: res => {
                    wait.close();
                    this.saveBlobToFile(res.body, 'ApplicationStatus' + schoolName + DateTime.now().toFormat('MMM_d_y'));
                }, error: error => {
                    wait.close();
                    this.errorSvc.HandleServiceError(error);
                }
            });
        });
    }

    saveBlobToFile(blob: Blob, fileName: string): void {
        //setup temporary in-memory URL and html tag
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = fileName;
        document.body.appendChild(anchor);

        //programattically click on tag for user
        anchor.click();

        //delete tag and URL
        document.body.removeChild(anchor);
        window.URL.revokeObjectURL(url);
    }

}
